import React, { useMemo } from 'react';
import { Select, Table } from 'antd';
import styled from 'styled-components';

import DocsLink from './docs/DocsLink';
import SimpleNavigationBar from './navigation/SimpleNavigationBar';

const { Option } = Select;

const columns = [
  {
    title: 'Path',
    dataIndex: 'path',
    sorter: (a, b) => a.path.localeCompare(b.path),
  },
  {
    title: 'Label',
    dataIndex: 'label',
    sorter: (a, b) => a.label.localeCompare(b.label),
  },
  {
    title: 'Type',
    dataIndex: 'type',
    sorter: (a, b) => a.type.localeCompare(b.type),
  },
  {
    title: 'Disabled',
    dataIndex: 'disabled',
    sorter: (a, b) => a.disabled.toString().localeCompare(b.disabled.toString()),
    render: (disabled) => `${disabled}`,
  },
];

const StyledFieldPathsView = styled.div`
  height: calc(100% - 63px);
  overflow-y: auto;

  .field-paths-view-wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
`;

const FieldPathsView = ({ onSearchEntryChange, searchEntry, searchEntries, paths, scrolTo }) => {
  const options = useMemo(() => {
    return [...searchEntries]
      .sort((a, b) => a.localeCompare(b))
      .map((se) => (
        <Option key={se} value={se}>
          {se}
        </Option>
      ));
  }, [searchEntries]);

  return (
    <>
      <SimpleNavigationBar />
      <StyledFieldPathsView>
        <div className="field-paths-view-wrapper">
          <div style={{ marginBottom: 16 }}>
            <Select
              showSearch
              placeholder="Search fields for..."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: 'auto', minWidth: 150 }}
              dropdownMatchSelectWidth
              dropdownStyle={{ width: 'auto' }}
              value={searchEntry || undefined}
              onSelect={(value) => onSearchEntryChange(value)}
              className="ant-select-border-bottom"
              getPopupContainer={(triggerNode) => triggerNode}
              virtual={false}
            >
              {options}
            </Select>
            <DocsLink scrolTo={scrolTo} styleIcon={{ fontSize: 20, margin: 5, color: 'gray' }} />
          </div>
          <Table
            columns={columns}
            dataSource={paths}
            size="small"
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              defaultPageSize: 50,
            }}
          />
        </div>
      </StyledFieldPathsView>
    </>
  );
};

export default FieldPathsView;
